import React from 'react';
import PropTypes from 'prop-types';

import LeadSettingModal from 'components/Modal/LeadSetting';
import DefaultAssignment from './DefaultAssignment';

const DefaultAssignmentModal = ({ open, onClose }) => {

  return (
    <LeadSettingModal
      open={open}
      onClose={onClose}
      title="Edit your default lead assignments."
    >
      <DefaultAssignment />
    </LeadSettingModal>
  );
};

DefaultAssignmentModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

DefaultAssignmentModal.defaultProps = {};

export default DefaultAssignmentModal;
